import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=d6d4847e&scoped=true"
import script from "./NewHome.vue?vue&type=script&lang=js"
export * from "./NewHome.vue?vue&type=script&lang=js"
import style0 from "./NewHome.scss?vue&type=style&index=0&id=d6d4847e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d4847e",
  null
  
)

export default component.exports